export enum AuthMethods {
    Apple = 'web_apple',
    Facebook = 'web_facebook',
    Google = 'web_google',
}

export enum SocialAuthErrorKey {
    Error = 'error',
}
export enum SocialAuthErrorValue {
    AlreadyExists = 'social register already_exists',
    CannotFetchToken = 'cannot fetch token',
}

export enum SocialAuthType {
    SocialAuth = 'SOCIAL_AUTH',
}

export enum SocialAuthMessage {
    AlreadyExists = 'social_register_already_exists',
    Canceled = 'auth_cancelled',
    Success = 'success',
}
